import React from 'react';

// #region imports

// Material-UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';

// Responsive hooks
import { useResponsive } from '../../hooks/UseResponsive';

// #endregion

const MyRequestsHelp: React.FC = () => {

  const { isMobile } = useResponsive();

  // #region Styles

  const theme = useTheme();
  const styles = {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
  };

  // #endregion

  return (
    <Box sx={styles.root}>
      <Typography variant="h6" paragraph gutterBottom>Lodge Use Requests</Typography>
      <Typography variant="button">Nightly Rates</Typography>
      <Typography variant={isMobile ? 'body2' : 'body1'}>Ski Season (12/1-4/30)</Typography>
      <Typography variant="body2">&diams; Weekend/Holiday nights - Friday &amp; Saturday as well as Sunday on designated holiday weekends</Typography>
      <Typography variant="body2" gutterBottom>&diams; Non-Weekend/Holidays nights - typically Sun-Thu nights</Typography>
      <Typography variant={isMobile ? 'body2' : 'body1'}>Off Season (5/1-11/30)</Typography>
      <Typography variant="body2" paragraph gutterBottom>&diams; All nights are the same rate</Typography>
      <Typography variant={isMobile ? 'body2' : 'body1'} paragraph>Meal charges are applicable when a meal is served and in addition to the nightly rate.</Typography>
      <Typography variant="body2" paragraph><i>Note: View the details on lodge fees in the Lodge folder in the Resources area.</i></Typography>
      <Typography component="div" variant="button">Request Types</Typography>
      <ul>
        <li><Typography variant={isMobile ? 'body2' : 'body1'}>Priority (P) - Designated as a priority request</Typography></li>
        <li><Typography variant={isMobile ? 'body2' : 'body1'}>Post Deadline (PD) - A request made after the signup deadline</Typography></li>
      </ul>
      <Typography component="div" variant="button">Categories</Typography>
      <ul>
        <li><Typography variant={isMobile ? 'body2' : 'body1'}>Current: You are currently at the lodge</Typography></li>
        <li><Typography variant={isMobile ? 'body2' : 'body1'}>Future: Members and guests can be added and cancelled</Typography></li>
        <li><Typography variant={isMobile ? 'body2' : 'body1'}>Past: Can be viewed but not edited</Typography></li>
        <li><Typography variant={isMobile ? 'body2' : 'body1'}>Cancellations: Entire request cancelled. Individual cancellations listed in other categories</Typography></li>
      </ul>
    </Box>
  )

  // #endregion

}

export default MyRequestsHelp;